import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import TabBar from "rc-tabs/lib/TabBar";
import { Link } from "react-router-dom";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import { TrasladosTab } from "../tabs/TrasladosTab/TrasladosTab";
import { FinalizadosTab } from "../tabs/FinalizadosTab/FinalizadosTab";
import { ProcesoTab } from "../tabs/ProcesoTab/ProcesoTab";
import "../styles/ListadoTraslados.css";

class RecepcionTraslados extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        // significa que fue carga nueva, por lo tanto no se conserva el estado anterior de filtros y página
        if (!tabFromUrl) {
            tabFromUrl = "EN_TRANSITO";

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });

            sessionStorage.removeItem(
                "traslados_recepcion_tab_en_transito_state",
            );
            sessionStorage.removeItem("traslados_recepcion_tab_recibido_state");
            sessionStorage.removeItem("traslados_recepcion_tab_proceso_state");
            sessionStorage.removeItem(
                "traslados_recepcion_tab_finalizado_state",
            );
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="traslados_activo"
                    titulo="TRASLADOS"
                    subtitulo="Solido"
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent />}
                    >
                        <TabPane tab="EN TRÁNSITO" key="EN_TRANSITO">
                            <TrasladosTab
                                estado="en_transito"
                                storageKey="traslados_recepcion_tab_en_transito_state"
                                modo="recepcion"
                            />
                        </TabPane>

                        <TabPane tab="RECIBIDOS" key="RECIBIDOS">
                            <TrasladosTab
                                estado="recibido"
                                storageKey="traslados_recepcion_tab_recibido_state"
                                modo="recepcion"
                            />
                        </TabPane>

                        <TabPane tab="PROCESO DE RECEPCIÓN" key="PROCESO">
                            <ProcesoTab
                                estado="proceso"
                                storageKey="traslados_recepcion_tab_proceso_state"
                            />
                        </TabPane>

                        <TabPane tab="FINALIZADOS" key="FINALIZADOS">
                            <FinalizadosTab
                                estado="finalizado"
                                storageKey="traslados_recepcion_tab_finalizado_state"
                                modo="recepcion"
                            />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

export default RecepcionTraslados;
